import * as React from 'react'; // eslint-disable-line
import { withStyles, Modal, Grid, Typography, Button } from '@material-ui/core';
import { connect, MapDispatchToProps } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import styles, { StyledComponent } from '../../../../../styles/styles';
import libertyLogo from '../../../../../resources/Liberty_Logo_Horizontal_White.svg';
import { AuthState } from '../../../../../auth/auth-reducer';
import { viewModalAction } from '../../../../../confirmation-dialog';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getDisplayNameFromAdName } from '../../../../../shared-functions';
import { HandleSubmit } from '../../../../../workflow-navigation';
import { communicationAction } from '../actions/communication-action';
import { Claim, getClaim } from '../../../../../claim';
import { ClaimantRequirements } from '../../../common/requirements-management/reducer';
import { DeathRequirements, getDocumentsRequirementsFromClaim } from '../reducer';
import { DeathClaim } from '../../../../../claim/reducers/claim-reducers/death-claim-reducer';

interface DispatchProps {
    closeModal?: any;
    sendCommunication: (payload: any) => Promise<any>;
}

type Props = StyledComponent &
    DispatchProps & {
        modal?: any;
        currentUser?: any;
        classes: any;
        modalBody: any;
        onSubmit?: HandleSubmit;
        claim?: Claim;
        claimantRequirements?: ClaimantRequirements[];
        lifeAssuredRequirements?: DeathRequirements;
    };

const communicationsPreviewEmailView: React.FunctionComponent<Props> = ({
    modal,
    currentUser,
    classes,
    closeModal,
    modalBody,
    onSubmit,
    sendCommunication,
    claim: propClaim,
    claimantRequirements: propClaimantRequirements,
    lifeAssuredRequirements: propLifeAssuredRequirements,
}: Props) => {
    async function submit() {
        try {
            if (onSubmit) {
                await onSubmit();
            }

            const formValues = modal?.form || {};

            let documents: any[] = [];
            let finalFormData = { ...formValues };

            if (propClaim && (propClaimantRequirements || propLifeAssuredRequirements)) {
                let requirements: any = [];
                let requestedDocuments: any[] = [];

                requirements = propClaimantRequirements?.find(
                    (item: any) => item.claimantId === formValues?.claimantId
                );

                requestedDocuments =
                    requirements && requirements.documents
                        ? requirements.documents.filter(
                              (document: any) => document.status === 'Requested'
                          )
                        : [];

                const claim = propClaim as DeathClaim;
                const claimants = claim?.contactDetails?.claimants;

                let claimant = claimants?.find(
                    (item: any) => item.value === formValues?.claimantId
                );

                if (!claimant && claimants && claimants.length > 0) {
                    claimant = claimants[0];
                }

                if (propLifeAssuredRequirements?.deceased) {
                    propLifeAssuredRequirements.deceased.forEach((document: any) => {
                        if (document.status === 'Requested') {
                            requestedDocuments.push({
                                id: document.id,
                                status: document.status,
                                reason: document.reason,
                                dateRequested: document.dateRequested,
                                name: document.name,
                            });
                        }
                    });
                }

                documents = requestedDocuments;

                finalFormData = {
                    communicationsEmailAddress:
                        formValues?.communicationsEmailAddress ??
                        claimant?.claimantDetails?.communicationDetails?.emailAddress,
                    to:
                        formValues?.communicationsEmailAddress ??
                        claimant?.claimantDetails?.communicationDetails?.emailAddress,
                    communicationsAdditionalEmails:
                        claimant?.claimantDetails?.communicationDetails?.emailAddress,
                    communicationsClaimant: formValues?.communicationsClaimant,
                    communicationsPolicy: formValues?.communicationsPolicy,
                    communicationsTitle: claimant?.claimantDetails?.personalDetails?.title,
                    claimantSurname: claimant?.claimantDetails?.personalDetails?.lastName,
                    claimantId: formValues?.communicationsClaimant ?? claimant?.id,
                    claimantName: claimant
                        ? `${claimant?.claimantDetails?.personalDetails?.title || ''} ${
                              claimant?.claimantDetails?.personalDetails?.firstName
                          } ${claimant?.claimantDetails?.personalDetails?.lastName || ''}`.trim()
                        : formValues?.communicationsClaimant,
                    idNumber:
                        formValues?.idNumber ??
                        claimant?.claimantDetails?.personalDetails?.idNumber,
                    requiredDocuments: requestedDocuments
                        .map((document: any) => document.name)
                        .join(', '),
                    communicationType: 'Missing Information',
                    claimDate: new Date().toISOString(),
                    assessor: getDisplayNameFromAdName(currentUser.name),
                    documents,
                };
            } else {
                documents =
                    formValues?.documents?.map((document: any) => ({
                        id: document.id,
                        status: document.status,
                        reason: document.reason,
                        dateRequested: document.dateRequested,
                        name: document.name,
                    })) || [];

                finalFormData = {
                    ...formValues,
                };
            }

            const correspondencePayload = {
                to: formValues?.communicationsEmailAddress,
                ccs: formValues?.communicationsAdditionalEmails
                    ? formValues.communicationsAdditionalEmails.filter(
                          (x: any) => x !== null && x !== undefined && x !== ''
                      )
                    : [],
                requiredDocuments: documents.map((d: any) => d.name).join(', '),
                claimantId: formValues?.communicationsClaimant,
                claimantName: finalFormData?.claimantSurname
                    ? `${finalFormData?.communicationsTitle || ''} ${
                          finalFormData?.claimantSurname || ''
                      }`.trim()
                    : formValues?.communicationsClaimant,
                idNumber: formValues?.idNumber,
                claimantPolicy: formValues?.communicationsPolicy,
                communicationsTitle: finalFormData?.communicationsTitle,
                communicationType: 'Missing Information',
                claimDate: new Date().toISOString(),
                documents,

                ...finalFormData,
            };

            await sendCommunication(correspondencePayload);

            closeModal({
                isOpen: false,
                isOpenModal: false,
                form: {},
            });
        } catch (error) {
            console.error('Failed to send communication', error);
        }
    }

    function onClose() {
        closeModal({
            isOpen: false,
            isOpenModal: false,
            form: modal?.form || {},
        });
    }

    return (
        <div>
            <Modal
                open={modal.isOpenModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Grid
                    item
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        padding: 10,
                        transform: 'translate(-50%, -50%)',
                        width: 600,
                        backgroundColor: '#ffffff',
                        height: '95vh',
                        minHeight: 400,
                        overflowX: 'hidden',
                        overflowY: 'scroll',
                        maxHeight: 750,
                    }}
                >
                    <Grid container>
                        <Grid
                            container
                            item
                            xs={12}
                            style={{
                                backgroundColor: '#0D1832',
                                marginBottom: 40,
                                height: 100,
                            }}
                        >
                            <Grid
                                direction="row"
                                justify="flex-end"
                                item
                                container
                                style={{
                                    paddingTop: 20,
                                    paddingRight: 20,
                                }}
                            >
                                <img
                                    src={libertyLogo}
                                    height={60}
                                    alt="liberty-flame-logo"
                                    className={classes.logo}
                                />
                            </Grid>
                        </Grid>

                        {modalBody && React.isValidElement(modalBody)
                            ? modalBody
                            : typeof modalBody === 'function'
                            ? modalBody()
                            : null}

                        <Typography>
                            <br />
                            We are always #Initwithyou
                            <br />
                            <br />
                            Kind Regards
                            <br />
                            {getDisplayNameFromAdName(currentUser.name)}
                            <br />
                            Death claims department
                            <br />
                            Liberty Group Limited
                        </Typography>
                    </Grid>

                    <Grid container spacing={0} justify="flex-end">
                        <Button
                            id="SendEmail"
                            type="button"
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            onClick={() => submit()}
                        >
                            Send E-mail
                        </Button>

                        <Button
                            id="Close"
                            type="button"
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
};

const mapDispatchToProps: MapDispatchToProps<any, any> = (
    dispatch: ThunkDispatch<State, any, AnyAction>
) => ({
    closeModal: (options: any) => dispatch(viewModalAction(options)),
    sendCommunication: (payload: any) => dispatch(communicationAction(payload)),
});

const mapStateToProps = (state: State) => ({
    modal: state.confirmationDialog,
    currentUser: state.auth as AuthState,
    onSubmit: state.claimSession.formSubmission.onSubmit,
    claim: getClaim(state),
    claimantRequirements:
        (getDocumentsRequirementsFromClaim(getClaim(state)) as DeathRequirements)?.claimants || [],
    lifeAssuredRequirements:
        (getDocumentsRequirementsFromClaim(getClaim(state)) as DeathRequirements) || [],
});

export const CommunicationsPreviewEmail = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(communicationsPreviewEmailView));
